import * as React from 'react';

import { CalendarActions, ICalendarState } from '@adage/ace-calendar';
import { IArenaEvent } from '../classes/event';
import { connect } from 'react-redux';


import { IOption } from '../../classes/index';

interface ExternalProps {
    id: string;
    svgId: string;
    accessibilityText: string;
    onChange: (accessibility: string, value: boolean) => any;
    shouldClear: boolean;
}

interface StateToProps {
}

interface AccessibilitySelectionState {
    isSelected: boolean;
}

type AccessibilitySelectionProps = ExternalProps & StateToProps;

export default class AccessibilityItem extends React.Component<AccessibilitySelectionProps, AccessibilitySelectionState> {
    constructor(props) {
        super(props);

        this.state = {
            isSelected: false,
        };
    }; 

    componentWillReceiveProps(props: AccessibilitySelectionProps) {
        if (props.shouldClear != this.props.shouldClear) {
            this.setState({ isSelected: false });
        }
    } 

    onChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.onChange(this.props.id, evt.target.checked);    
        this.setState({ isSelected: evt.target.checked });
    }

    render() {
        return (
            <div className="cal-filters-accessibility">
                <input id={this.props.id} type="checkbox" onChange={this.onChange.bind(this)} checked={this.state.isSelected} />
                <label htmlFor={this.props.id}>                                 
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={this.props.svgId} />
                    </svg>
                    {this.props.accessibilityText}                                                      
                </label>    
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/calendar/components/accessibility-item.tsx